import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useStoreSelector } from "../../helpers/hooks/useStoreSelector";
import { useAuthStore } from "../../store/states/useAuthStore";

interface Props {
  children?: React.ReactNode;
}

const UnAuthGuard = ({ children }: Props) => {
  const { token } = useStoreSelector(useAuthStore, "token");

  return !token ? (children || <Outlet />) as React.ReactElement : <Navigate to={"/gestione"} />;
};

export default UnAuthGuard;
